import { useState } from "react";
import { Tabs } from "@therms/atalaya";
import { Fragment as Fragment$1, jsx, jsxs } from "react/jsx-runtime";
//#region src/modules/FormBuilder/components/Fields/components/withFieldConfigLayoutTabs.tsx
function withFieldConfigLayoutTabs(WrappedComponent) {
	const displayName = WrappedComponent.displayName || WrappedComponent.name || "Component";
	const ComponentWithFieldConfigLayoutTabs = (props) => {
		const [localLayoutType, setLocalLayoutType] = useState(props.layoutType || "Form");
		return /* @__PURE__ */ jsxs(Fragment$1, { children: [
			/* @__PURE__ */ jsxs(Tabs, {
				fullWidth: true,
				initialTabKey: localLayoutType,
				onTabClick: setLocalLayoutType,
				children: [/* @__PURE__ */ jsx(Tabs.Tab, { title: "Form" }), /* @__PURE__ */ jsx(Tabs.Tab, { title: "Display" })]
			}),
			/* @__PURE__ */ jsx("div", { className: "mb-2" }),
			/* @__PURE__ */ jsx(WrappedComponent, {
				...props,
				layoutType: localLayoutType
			})
		] });
	};
	ComponentWithFieldConfigLayoutTabs.displayName = `withFieldConfigLayoutTabs(${displayName})`;
	return ComponentWithFieldConfigLayoutTabs;
}
//#endregion
export { withFieldConfigLayoutTabs };

//# sourceMappingURL=withFieldConfigLayoutTabs.js.map